import React from 'react';
import { Empty, Table } from '@maxtropy/components';
import styles from './index.module.scss';
import powerIcon from '../../assets/power-icon.png';
import prIcon from '../../assets/pr-icon.png';
import solarPanel from '../../assets/solar-panel.png';
import { getAreaLineOption } from '../../chartOptions';
import { Point } from '../../type';
import ChartBlock from '../ChartBlock';
import SectionPanel from '../SectionPanel';

const iconMap = {
  pr: prIcon,
  power: powerIcon,
  solar: solarPanel,
};

const columns = [
  {
    title: '时间',
    dataIndex: 'time',
    width: 150,
  },
  {
    title: 'PR',
    dataIndex: 'value',
    width: 80,
  },
];

interface PRPanelProps {
  pr: {
    cards: { icon: string; label: string; value: string }[];
    line: Point[];
    table: { time: string; value: string }[];
  };
}

const PRPanel: React.FC<PRPanelProps> = ({ pr }) => {
  const hasChartData = pr.line.length > 0;

  return (
    <SectionPanel title="光伏绩效（PR）" bodyClassName={styles.panelBody}>
      <div className={styles.prMetrics}>
        {pr.cards.map(item => (
          <div className={styles.prMetricCard} key={item.label}>
            <img className={styles.prMetricIcon} src={iconMap[item.icon as keyof typeof iconMap]} alt="" />
            <span className={styles.prMetricLabel}>{item.label}：</span>
            <span className={styles.prMetricValue}>{item.value}</span>
          </div>
        ))}
      </div>
      <div className={styles.prContent}>
        <div className={styles.prChart}>
          {hasChartData ? (
            <ChartBlock
              option={getAreaLineOption(pr.line, '#52E7FF', '%', {
                areaStartColor: 'rgba(82,231,255,0.3)',
                areaEndColor: 'rgba(82,231,255,0)',
                lineWidth: 2,
                seriesName: 'PR',
                showLegend: true,
              })}
              height={288}
            />
          ) : (
            <Empty className={styles.empty} description="暂无数据" />
          )}
        </div>
        <div className={styles.prTable}>
          <Table rowKey="time" columns={columns} dataSource={pr.table} pagination={false} scroll={{ y: 224 }} />
        </div>
      </div>
    </SectionPanel>
  );
};

export default PRPanel;
